import React, { Suspense, useEffect } from "react";
import Loading from "@components/atoms/Loading";
import {
  usePreloadedQuery,
  useQueryLoader,
  graphql,
  PreloadedQuery,
} from "react-relay/hooks";
import SnsLogin from "@components/templates/SnsLogin";
import _ from "lodash";
import { SnsLoginScreenQuery } from "@generated/SnsLoginScreenQuery.graphql";

const screenQuery = graphql`
  query SnsLoginScreenQuery {
    influencer {
      ...SnsLogin
    }
  }
`;

function ScreenContent({
  queryReference,
}: {
  queryReference: PreloadedQuery<SnsLoginScreenQuery>;
}) {
  const { influencer } = usePreloadedQuery<SnsLoginScreenQuery>(
    screenQuery,
    queryReference
  );
  return <SnsLogin snsFragment={influencer} />;
}

export default function SnsLoginScreen(): JSX.Element {
  const [queryReference, loadQuery, disposeQuery] =
    useQueryLoader<SnsLoginScreenQuery>(screenQuery);
  useEffect(() => {
    loadQuery({});
    return () => {
      disposeQuery();
    };
  }, [loadQuery, disposeQuery]);

  return (
    <Suspense fallback={<Loading size="large" />}>
      {!_.isNil(queryReference) && (
        <ScreenContent queryReference={queryReference} />
      )}
    </Suspense>
  );
}
